import {useIsFocused, useNavigation} from '@react-navigation/native';
import {useEffect} from 'react';

import {config} from '@/constants/config';
import {RootStackNavigationParams} from '@/types/routes';

export const useEmbedColorsListener = () => {
  const navigation = useNavigation<RootStackNavigationParams>();
  const isFocused = useIsFocused();

  useEffect(() => {
    if (isFocused) {
      const handler = (event: MessageEvent) => {
        if (event.origin !== config.EMBED_PAGE_URL) {
          return;
        }

        if (
          event.data?.type === 'colors' &&
          typeof event.data?.colors === 'string'
        ) {
          navigation.setParams({colors: event.data.colors});
        }
      };

      window.addEventListener('message', handler, false);

      return () => window.removeEventListener('message', handler, false);
    }
  }, [isFocused]);
};
